import React, { useState, useEffect } from 'react';
import "./toast.styles.css"

const Toast = ({ message, duration = 2000, onClose, backgroundColor = 'black', color = "white" }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onClose?.();
    }, duration);
    return () => clearTimeout(timer);
  }, [duration, onClose]);

  if (!visible) return null;

  return (
    <div className="toast" style = {{backgroundColor, color, display: 'inline-block', whiteSpace: 'nowrap'}}>
      {message}
    </div>
  )
}

export default Toast